export const RECORD_STORE = {
  SERVICE: 'Bandcamp',
};